<template>
    <div class="mobile_screen">
        <div class="big_cat_screen">
            <HeaderNav v-if="!isWeixinBrowser()" :navtitle="courseTitle" :beforecolor="'#000'" :backcolor="'#fff'" @returnBack="goToBack"/>
            <div class="imgLazyLoadHead">
                <img v-bind:src="getheadImage()"/>
                <div class="entry course_intro"><div class="entry_back" @click="courseIntroClick"><span>课程介绍 ></span></div></div>
                <div class="entry faq"><div class="entry_back" @click="faqClick"><span>家长指导 ></span></div></div>
                <div class="entry contact_master"><div class="entry_back" @click="contactClick"><span>联系班主任 ></span></div></div>
            </div>
            <div class="page-navbar">
                <mt-navbar v-if="objMathStartHomeInfo.isBuy === 1" class="page-part" v-model="selected">
                    <mt-tab-item id="1" :style="parseInt(selected) === 1 ? isSelected(courseId) : {cursor: 'pointer'}">图书列表</mt-tab-item>
                    <mt-tab-item id="2" :style="parseInt(selected) === 2 ? isSelected(courseId) : {cursor: 'pointer'}">词汇表</mt-tab-item>
                    <mt-tab-item id="3" :style="parseInt(selected) === 3 ? isSelected(courseId) : {cursor: 'pointer'}">打卡动态</mt-tab-item>
                    <div class="page_navbar_click" @click="PunchDynamicsClick"></div>
                </mt-navbar>
                <div class="sty_tab_container">
                    <mt-tab-container v-model="selected" :style="{backgroundColor:getProgramCourseBGColor(courseId2)}">
                        <mt-tab-container-item id="1">
                            <div class="course_list_content" v-bind:style="{backgroundColor:getProgramCourseBGColor(courseId2)}">
                                <div class="course_top"></div>
                                <!--试听-->
                                <template v-if="objMathStartHomeInfo.isBuy === 0">
                                    <BigCat5Item :style="{'padding-top':'0px'}" :lessonArray="objMathStartHomeInfo.freeTrial" :selectedLessonPk="freeTrialSelectedPk.toString()"
                                                 :isFreeTrial="'1'" @lessonItemClick="lessonItemClick"/>

                                    <div class="course_list_title">- 图书列表 -</div>
                                </template>

                                <BigCat5Item :style="{'padding-top':'0px'}" :lessonArray="objMathStartHomeInfo.lessonArray" :selectedLessonPk="selectedLessonPk.toString()"
                                             @lessonItemClick="lessonItemClick"/>

                                <div class="lesson_list_bottom"></div>
                            </div>
                        </mt-tab-container-item>
                        <mt-tab-container-item id="2" v-if="objMathStartHomeInfo.isBuy === 1">
                            <div :style="{backgroundColor:getProgramCourseWordColor(courseId2), marginBottom:'80px'}">
                                <div class="Words_glossary_item" v-for="(item,index) in WordsGlossaryArray" :key="index">
                                    <div :id="'section_' + item.initial" :style="{'padding-top':(44 + getStatusHeight())+'px', 'margin-top': '-'+(44 + getStatusHeight())+'px'}">
                                        <div class="section_title">{{item.initial}}</div>
                                    </div>
                                    <div class="Words_glossary_wordsitem" v-for="(section,index) in item.sections" :key="index"
                                         @click="wordClick(section.youdaoUrl, section.pk, section.word)">
                                        <div class="Word" :style="{color:'#333333'}">
                                            {{section.word}}
                                            <span v-if="getCount(section.subscript) > 0">{{getCount(section.subscript)}}</span>
                                        </div>
                                        <div class="point">···············</div>
                                        <div class="lesson_name">{{"#" + section.lessonNo}}</div>
                                        <div class="clear"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="Words_glossary_indexs">
                                <div class="Words_glossary_indexsitem" v-for="(item,index) in WordsGlossaryArray" :key="index"
                                     @click="scrollToPositin(item.initial)">
                                    {{item.initial}}
                                </div>
                            </div>
                        </mt-tab-container-item>
                    </mt-tab-container>
                </div>
            </div>
            <div class="bottom_tool" v-if="objMathStartHomeInfo.isBuy === 0" :style="{height: adapterBigScreenHeight()}">
                <div class="tabbar_buy" @click="buyProgram">
                    <span>购买课程</span>
                    <div class="go">立即前往</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {MessageBox} from "mint-ui";
    import Vue from "vue";
    import Utils from "@/pages/Program/util2";

    export default {
        data() {
            return {
                selected: '1',
                courseTitle: "",
                courseId: parseInt(this.$route.query.courseId),
                courseId2: 0,
                objMathStartHomeInfo: {},
                totalPartCount: 4,
                WordsGlossaryArray: [],
                objExperience: {},
                tabId: 0,
                selectedLessonPk:0,
                freeTrialSelectedPk:0
            }
        },
        methods: {
            PunchDynamicsClick() {
                if (this.isAppIos()) {
                    document.location = "readingclubapp:punchDynamicsClick:" + 1 + ":" + this.courseId + ":" + 0;
                }

                if (this.isAppAndroid()) {
                    // 打卡动态
                    window.note.punchDynamicsClick(1, this.courseId, 0);
                }
            },
            setFinishPart(pk, type) {
                let that = this;
                // 1词汇/2思维导图/3数学练习/4拓展
                let vType = parseInt(type);
                let url = "mathStart/setFinishPart/" + pk + "/" + vType;

                that.$axios.get(url).then((response) => {
                    let vLesson = response.data;
                    let isFinished = that.getCount(vLesson.finish);

                    // 1单节课全部完成/0还未完成/-1异常
                    if (isFinished === 1) {
                        that.objMathStartHomeInfo.lessonArray.forEach((item, index) => {
                            if (pk === item.pk) {
                                item.finish = 1;
                                Vue.set(that.objMathStartHomeInfo.lessonArray, index, item);
                            }
                        });
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            adapterBigScreenHeight: function () {
                return this.judgeBigScreen() ? "86px" : "50px";
            },
            judgeBigScreen: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return false;
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值
                return rate > limit;
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            buyProgram: function () {
                // 购买流程
                let that = this;
                let vPlatform = that.judgePlatform();
                let vYouZanUrl = this.objMathStartHomeInfo.buyUrl.replace(new RegExp('https:','g'), '');

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:buyMathStartCourse:" + that.courseId + ":" + vYouZanUrl;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.buyMathStartCourse(that.courseId, that.objMathStartHomeInfo.buyUrl);
                }
            },
            buyCourseSuccess: function () {
                let that = this;
                that.objMathStartHomeInfo.isBuy = 1;
            },
            courseIntroClick: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:viewCourseIntro:" + that.objMathStartHomeInfo.articleId;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.viewCourseIntro(that.objMathStartHomeInfo.articleId);
                }
            },
            faqClick: function () {
                let that = this;
                let vPlatform = that.judgePlatform();
                let courseType = 7;

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:viewCourseFaq:" + courseType + ":" + that.courseId;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.viewCourseFaq(courseType, that.courseId);
                }
            },
            contactClick: function () {
                this.$router.push({name: "BFHeadMaster", query: {courseId: this.courseId, courseType: 2}});
            },
            goToBack() {
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (!this.isEmpty(token) && !this.isEmpty(userid) && token.length > userid.length) {
                    if (this.isAppIos()) {
                        document.location = "readingclubapp:gobackMyCourse";
                    }

                    if (this.isAppAndroid()) {
                        window.note.gobackMyCourse();
                    }
                } else {
                    this.goBack(this.$router);
                }
            },
            getStatusHeight() {
                let statusHeight = this.getCount(this.$store.state.statusheight);

                if (statusHeight === 0) {
                    statusHeight = 20;
                }

                return statusHeight;
            },
            showStatus: function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            showStatusWhiteDelay(status) {
                let that = this;

                setTimeout(() => {
                    that.showStatusWhite(status);
                }, 200);
            },
            showStatusWhite:function (status) {
                let that = this;

                if (that.isAppIos()) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (that.isAppAndroid()) {
                    window.note.changeStatusStyle(status);
                }
            },
            getheadImage:function(){
                return require('@/Images/math_start_head.png');
            },
            lessonItemClick:function(isFreeTrial, pk) {
                if (isFreeTrial === 0 && this.objMathStartHomeInfo.isBuy === 0) {
                    this.buyTipClick();
                    return;
                }

                this.$router.push({
                    name: 'MLesson',
                    query: {lessonId: pk, courseId: this.courseId}
                });
            },
            buyTipClick:function(){
                MessageBox.confirm('', {
                    message: ' ',
                    title: '要先购买才能上课哦～快去购买吧！',
                    showConfirmButton:false,
                    showCancelButton:true,
                    closeOnClickModal: false,
                    cancelButtonClass:'cancelButton',
                    confirmButtonClass:'confirmButton',
                    cancelButtonText:'知道了'
                });
            },
            wordClick: function (youdaoUrl, wordId, word) {
                if (!this.isEmpty(youdaoUrl)) {
                    this.$router.push({name: 'pageView', query: {url: "https://m.youdao.com/dict?le=eng&q=" + word}});
                } else {
                    this.$router.push({
                        name: 'MCard', query: {wordId: wordId}
                    });
                }
            },
            isSelected(id) {
                return {
                    color: "#ff5050",
                    'border-bottom': '3px solid #ff5050',
                    cursor: 'pointer'
                };
            },
            getFirstLettersArray(array) {
                let firstLetters = [];

                array.forEach(item => {
                    if (firstLetters.indexOf(item.firstLetter) === -1) {
                        firstLetters.push(item.firstLetter);
                    }
                });

                return firstLetters;
            },
            scrollToPositin(section) {
                document.getElementById('section_' + section).scrollIntoView();
            }
        },
        created() {
            let that = this;

            // 客户端调用方法组
            window.buyCourseSuccess = that.buyCourseSuccess;
        },
        beforeCreate() {
            let that = this;
            let vCourseId = parseInt(that.$route.query.courseId);
            let url = "/mathStart/getHomeInfo/" + vCourseId;

            that.$axios.get(url).then((response) => {
                that.courseTitle = "Math Start";
                that.objMathStartHomeInfo = response.data;
                that.courseId = vCourseId;
                that.courseId2 = vCourseId;

                that.objMathStartHomeInfo.lessonArray.forEach((itemLesson) => {
                    if (that.getCount(itemLesson.finish) === 0 && that.selectedLessonPk === 0) {
                        that.selectedLessonPk = itemLesson.pk;
                    }
                });

                if (that.selectedLessonPk === 0) {
                    let lesson = that.objMathStartHomeInfo.lessonArray[0];
                    that.selectedLessonPk = lesson.pk;
                }
            }).catch(function (error) {
                window.console.log(error)
            });

            let url2 = "/mathStart/getGlossary/" + vCourseId;

            that.$axios.get(url2).then((response) => {
                let wordsGlossarys = response.data;

                if (that.isEmpty(wordsGlossarys)) {
                    return;
                }

                let firstLetters = that.getFirstLettersArray(wordsGlossarys);

                firstLetters.forEach(initial => {
                    let sections = wordsGlossarys.filter(wordsGlossary => wordsGlossary.firstLetter === initial);
                    that.WordsGlossaryArray.push({
                        initial,
                        sections
                    });
                })
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        mounted() {
            window.BAfterScrollTop = 0;
            let that = this;

            Utils.$on('setFinishPart', function (pk, type) {
                that.setFinishPart(pk, type);
            });
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatus(1);
                vm.showStatusWhiteDelay(0);
            });
        },
        beforeRouteLeave(to, from, next) {
            this.showStatus(0);
            window.BAfterScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.BAfterScrollTop);
        }
    }
</script>
<style scoped>

    img { pointer-events: none; }

    .mobile_screen {
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }
    .course_list_guidance {
        text-align: center;
    }
    .course_list_guidance .guidance {
        color: #666666;
        font-size: 15px;
        width: 90px;
        text-align: center;
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
        display: inline-block;
    }
    .imgLazyLoadHead {
        position: relative;
        padding: 0px;
    }
    .imgLazyLoadHead img {
        display: block;
        width: 100%;
        margin: auto;
    }
    .imgLazyLoadHead .entry {
        width: 33.3vmin;
        position: absolute;
        bottom: 15px;
        display: flex;
        justify-content: center;
    }
    .imgLazyLoadHead span {
        color: white;
        font-size: 13px;
    }
    .imgLazyLoadHead .entry_back {
        width: 100px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        background-color: #ffffffdb;
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
    }
    .imgLazyLoadHead .entry_back img {
        width: 15px;
        height: 15px;
    }
    .entry_back span {
        color: #333333;
    }
    .imgLazyLoadHead .faq {
        left: 33.3vmin;
    }
    .imgLazyLoadHead .contact_master {
        left: 66.6vmin;
    }

    .course_list_title {
        font-size: 15px;
        color: #6B6B6B;
        text-align: center;
        padding-top: 30px;
    }

    .course_top {
        height: 10px;
    }

    .clear {
        clear: both;
        line-height: 0;
        font-size: 0;
        height: 0;
        over-flow: hidden;
    }
    .lesson_list_bottom {
        height: 50px;
    }
    .tab_title {
        font-size: 15px;
        font-weight: bold;
    }
    .Words_glossary_item .section_title {
        background-color: #f4f4f4;
        text-align: left;
        height: 25px;
        font-size: 14px;
        color: #666666;
        line-height: 25px;
        padding-left: 15px;
    }
    .Words_glossary_wordsitem {
        position: relative;
        height: 60px;
    }
    .Words_glossary_wordsitem .Word {
        position: absolute;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        padding: 5px 16px 5px 16px;
        left: 20px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        background-color: white;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
    }
    .Words_glossary_wordsitem .Word span {
        position: absolute;
        top: 3px;
        right: 5px;
        font-size: 10px;
        color: #999999;
        font-weight: normal;
    }
    .Words_glossary_wordsitem .point {
        text-align: center;
        font-size: 14px;
        color: #333;
        position: absolute;
        left: 70%;
        top: 50%;
        -webkit-transform: translateX(-70%) translateY(-50%);
    }
    .Words_glossary_wordsitem .lesson_name {
        position: absolute;
        text-align: left;
        right: 30px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        color: #333333;
        font-size: 15px;
    }
    .Words_glossary_indexs {
        position: fixed;
        bottom: 50px;
        right: 0;
        z-index: 999;
    }
    .Words_glossary_indexs .Words_glossary_indexsitem {
        font-size: 10px;
        font-weight: bold;
        color: #333333;
        height: 15px;
        width: 25px;
    }
    .bubbleContainer{
        position: absolute;
        bottom: 0px;
        left: calc(100%/3 + (100%/3 - 120px)/2);
        padding-bottom: 6px;
    }
    .sty_tab_container {
        position: relative;
    }
    .bubbleContainer2{
        position: absolute;
        top: 5px;
        right: 0;
        padding-bottom: 6px;
        z-index: 9999;
    }
    .bubbleContainer .text, .bubbleContainer2 .text {
        color: white;
        background-color: #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 10px 3px 10px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer .img {
        position: absolute;
        bottom: 0;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer2 .img {
        position: absolute;
        top: -12px;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer .img img, .bubbleContainer2 .img img {
        width: 12px;
    }
    .page {
        background-color: white;
        min-height: 70vh;
    }
    .experience_title
    {
        font-size: 25px;
        color: #333333;
        font-weight: bold;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 5px;
        padding-top: 15px;
        text-align: left;
    }
    .content_top {
        height: 30px;
    }
    .content_margin
    {
        margin-left: 15px;
        margin-right: 15px;
        padding-bottom: 85px;
    }
    .span_experience_content {
        text-align: left;
    }
    .ck-editor-content
    {
        color: #333;
        margin-bottom: 20px;
        font: 17px/1.8 "Microsoft YaHei" ,Arial,Helvetica,sans-serif, "宋体";
        letter-spacing:1px;
    }
    .ck-editor-content p
    {
        margin-top:0px;
        margin-bottom:0px;
        word-wrap: break-word;
    }
    .ck-editor-content blockquote {
        overflow: hidden;
        padding-right: 1.5em;
        padding-left: 1.5em;
        margin-left: 0;
        border-left: 5px solid #ccc;
        margin-top:0px;
        margin-bottom:0px;
    }
    .ck-editor-content figcaption
    {
        color: #999;
        font-size: .75em;
        outline-offset: -1px;
        padding-top: .6em;
        text-align:center;

    }
    .ck-editor-content figure
    {
        padding:0px;
        margin-left:0px;
        margin-right:0px;
        margin-top:10px;
        margin-bottom:10px;
        text-align: center;
    }
    .ck-editor-content figure img
    {
        border:0px;
        max-width: 100%;
    }
    .ck-editor-content >>> .image {
        padding: 0;
        margin: 0;
    }
    .try_listen {
        position: absolute;
        background-color: red;
        color: white;
        top: 0;
        right: 0;
        font-size: 10px;
        padding: 2px 5px;
        border-top-right-radius: 5px;
        border-bottom-left-radius: 10px;
        -webkit-border-top-right-radius: 5px;
        -moz-border-top-right-radius: 5px;
    }
    .new_hint {
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .new_hint img {
        width: 100px;
        height: 100px;
    }
    .new_hint_content {
        width: 100%;
        display: flex;
        justify-content: center;
        color: #999999;
        font-size: 15px;
        margin-bottom: 100px;
    }
    .bottom_tool {
        position: fixed;
        background-color: #f4f4f4;
        width: 100%;
        z-index: 10000;
        bottom: 0;
        height: 50px;
    }
    .tabbar_buy {
        display: flex;
        height: 50px;
        background-color: #ff505a;
        width: 100%;
        z-index: 10000;
        align-items: center;
        justify-content: center;
    }
    .tabbar_buy span {
        color: white;
        font-size: 17px;
        text-align: center;

    }
    .tabbar_buy .go {
        position: absolute;
        height: 26px;
        line-height: 26px;
        right: 15px;
        background-color: white;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 13px;
        color: #ff505a;
        text-align: center;
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
    }
    .page_navbar_click {
        position: absolute;
        right: 0;
        width: calc(100%/3);
        height: 50px;
    }

</style>
